"use strict";

var _defineProperty = require("C:/__w/1/s/ManagedLabs/src/Client/node_modules/@babel/runtime/helpers/defineProperty");
var _slicedToArray = require("C:/__w/1/s/ManagedLabs/src/Client/node_modules/@babel/runtime/helpers/slicedToArray");
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var conversions = require("webidl-conversions");
var utils = require("./utils.js");
var impl = utils.implSymbol;
var IteratorPrototype = Object.create(utils.IteratorPrototype, _defineProperty({
  next: {
    value: function next() {
      var internal = this[utils.iterInternalSymbol];
      var target = internal.target,
        kind = internal.kind,
        index = internal.index;
      var values = Array.from(target[impl]);
      var len = values.length;
      if (index >= len) {
        return {
          value: undefined,
          done: true
        };
      }
      var pair = values[index];
      internal.index = index + 1;
      var _pair$map = pair.map(utils.tryWrapperForImpl),
        _pair$map2 = _slicedToArray(_pair$map, 2),
        key = _pair$map2[0],
        value = _pair$map2[1];
      var result;
      switch (kind) {
        case "key":
          result = key;
          break;
        case "value":
          result = value;
          break;
        case "key+value":
          result = [key, value];
          break;
      }
      return {
        value: result,
        done: false
      };
    },
    writable: true,
    enumerable: true,
    configurable: true
  }
}, Symbol.toStringTag, {
  value: "URLSearchParamsIterator",
  writable: false,
  enumerable: false,
  configurable: true
}));
function URLSearchParams() {
  var args = [];
  for (var i = 0; i < arguments.length && i < 1; ++i) {
    args[i] = arguments[i];
  }
  if (args[0] !== undefined) {
    if (utils.isObject(args[0])) {
      if (args[0][Symbol.iterator] !== undefined) {
        if (!utils.isObject(args[0])) {
          throw new TypeError("Failed to construct 'URLSearchParams': parameter 1" + " sequence" + " is not an iterable object.");
        } else {
          var V = [];
          var tmp = args[0];
          var _iterator = _createForOfIteratorHelper(tmp),
            _step;
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var nextItem = _step.value;
              if (!utils.isObject(nextItem)) {
                throw new TypeError("Failed to construct 'URLSearchParams': parameter 1" + " sequence" + "'s element" + " is not an iterable object.");
              } else {
                var _V = [];
                var _tmp = nextItem;
                var _iterator2 = _createForOfIteratorHelper(_tmp),
                  _step2;
                try {
                  for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                    var _nextItem = _step2.value;
                    _nextItem = conversions["USVString"](_nextItem, {
                      context: "Failed to construct 'URLSearchParams': parameter 1" + " sequence" + "'s element" + "'s element"
                    });
                    _V.push(_nextItem);
                  }
                } catch (err) {
                  _iterator2.e(err);
                } finally {
                  _iterator2.f();
                }
                nextItem = _V;
              }
              V.push(nextItem);
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
          args[0] = V;
        }
      } else {
        if (!utils.isObject(args[0])) {
          throw new TypeError("Failed to construct 'URLSearchParams': parameter 1" + " record" + " is not an object.");
        } else {
          var result = Object.create(null);
          var _iterator3 = _createForOfIteratorHelper(Reflect.ownKeys(args[0])),
            _step3;
          try {
            for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
              var key = _step3.value;
              var desc = Object.getOwnPropertyDescriptor(args[0], key);
              if (desc && desc.enumerable) {
                var typedKey = key;
                var typedValue = args[0][key];
                typedKey = conversions["USVString"](typedKey, {
                  context: "Failed to construct 'URLSearchParams': parameter 1" + " record" + "'s key"
                });
                typedValue = conversions["USVString"](typedValue, {
                  context: "Failed to construct 'URLSearchParams': parameter 1" + " record" + "'s value"
                });
                result[typedKey] = typedValue;
              }
            }
          } catch (err) {
            _iterator3.e(err);
          } finally {
            _iterator3.f();
          }
          args[0] = result;
        }
      }
    } else {
      args[0] = conversions["USVString"](args[0], {
        context: "Failed to construct 'URLSearchParams': parameter 1"
      });
    }
  } else {
    args[0] = "";
  }
  iface.setup(this, args);
}
Object.defineProperty(URLSearchParams, "prototype", {
  value: URLSearchParams.prototype,
  writable: false,
  enumerable: false,
  configurable: false
});
Object.defineProperty(URLSearchParams.prototype, Symbol.iterator, {
  writable: true,
  enumerable: false,
  configurable: true,
  value: function entries() {
    if (!this || !module.exports.is(this)) {
      throw new TypeError("Illegal invocation");
    }
    return module.exports.createDefaultIterator(this, "key+value");
  }
});
URLSearchParams.prototype.forEach = function forEach(callback) {
  if (!this || !module.exports.is(this)) {
    throw new TypeError("Illegal invocation");
  }
  if (arguments.length < 1) {
    throw new TypeError("Failed to execute 'forEach' on 'URLSearchParams': 1 argument required, " + "but only 0 present.");
  }
  if (typeof callback !== "function") {
    throw new TypeError("Failed to execute 'forEach' on 'URLSearchParams': The callback provided " + "as parameter 1 is not a function.");
  }
  var thisArg = arguments[1];
  var pairs = Array.from(this[impl]);
  var i = 0;
  while (i < pairs.length) {
    var _pairs$i$map = pairs[i].map(utils.tryWrapperForImpl),
      _pairs$i$map2 = _slicedToArray(_pairs$i$map, 2),
      key = _pairs$i$map2[0],
      value = _pairs$i$map2[1];
    callback.call(thisArg, value, key, this);
    pairs = Array.from(this[impl]);
    i++;
  }
};
URLSearchParams.prototype.append = function append(name, value) {
  var _this$impl;
  if (!this || !module.exports.is(this)) {
    throw new TypeError("Illegal invocation");
  }
  if (arguments.length < 2) {
    throw new TypeError("Failed to execute 'append' on 'URLSearchParams': 2 " + "arguments required, but only " + arguments.length + " present.");
  }
  var args = [];
  for (var i = 0; i < arguments.length && i < 2; ++i) {
    args[i] = arguments[i];
  }
  args[0] = conversions["USVString"](args[0], {
    context: "Failed to execute 'append' on 'URLSearchParams': parameter 1"
  });
  args[1] = conversions["USVString"](args[1], {
    context: "Failed to execute 'append' on 'URLSearchParams': parameter 2"
  });
  return (_this$impl = this[impl]).append.apply(_this$impl, args);
};
URLSearchParams.prototype.delete = function _(name) {
  var _this$impl2;
  if (!this || !module.exports.is(this)) {
    throw new TypeError("Illegal invocation");
  }
  if (arguments.length < 1) {
    throw new TypeError("Failed to execute 'delete' on 'URLSearchParams': 1 " + "argument required, but only " + arguments.length + " present.");
  }
  var args = [];
  for (var i = 0; i < arguments.length && i < 1; ++i) {
    args[i] = arguments[i];
  }
  args[0] = conversions["USVString"](args[0], {
    context: "Failed to execute 'delete' on 'URLSearchParams': parameter 1"
  });
  return (_this$impl2 = this[impl]).delete.apply(_this$impl2, args);
};
URLSearchParams.prototype.get = function get(name) {
  var _this$impl3;
  if (!this || !module.exports.is(this)) {
    throw new TypeError("Illegal invocation");
  }
  if (arguments.length < 1) {
    throw new TypeError("Failed to execute 'get' on 'URLSearchParams': 1 " + "argument required, but only " + arguments.length + " present.");
  }
  var args = [];
  for (var i = 0; i < arguments.length && i < 1; ++i) {
    args[i] = arguments[i];
  }
  args[0] = conversions["USVString"](args[0], {
    context: "Failed to execute 'get' on 'URLSearchParams': parameter 1"
  });
  return (_this$impl3 = this[impl]).get.apply(_this$impl3, args);
};
URLSearchParams.prototype.getAll = function getAll(name) {
  var _this$impl4;
  if (!this || !module.exports.is(this)) {
    throw new TypeError("Illegal invocation");
  }
  if (arguments.length < 1) {
    throw new TypeError("Failed to execute 'getAll' on 'URLSearchParams': 1 " + "argument required, but only " + arguments.length + " present.");
  }
  var args = [];
  for (var i = 0; i < arguments.length && i < 1; ++i) {
    args[i] = arguments[i];
  }
  args[0] = conversions["USVString"](args[0], {
    context: "Failed to execute 'getAll' on 'URLSearchParams': parameter 1"
  });
  return utils.tryWrapperForImpl((_this$impl4 = this[impl]).getAll.apply(_this$impl4, args));
};
URLSearchParams.prototype.has = function has(name) {
  var _this$impl5;
  if (!this || !module.exports.is(this)) {
    throw new TypeError("Illegal invocation");
  }
  if (arguments.length < 1) {
    throw new TypeError("Failed to execute 'has' on 'URLSearchParams': 1 " + "argument required, but only " + arguments.length + " present.");
  }
  var args = [];
  for (var i = 0; i < arguments.length && i < 1; ++i) {
    args[i] = arguments[i];
  }
  args[0] = conversions["USVString"](args[0], {
    context: "Failed to execute 'has' on 'URLSearchParams': parameter 1"
  });
  return (_this$impl5 = this[impl]).has.apply(_this$impl5, args);
};
URLSearchParams.prototype.set = function set(name, value) {
  var _this$impl6;
  if (!this || !module.exports.is(this)) {
    throw new TypeError("Illegal invocation");
  }
  if (arguments.length < 2) {
    throw new TypeError("Failed to execute 'set' on 'URLSearchParams': 2 " + "arguments required, but only " + arguments.length + " present.");
  }
  var args = [];
  for (var i = 0; i < arguments.length && i < 2; ++i) {
    args[i] = arguments[i];
  }
  args[0] = conversions["USVString"](args[0], {
    context: "Failed to execute 'set' on 'URLSearchParams': parameter 1"
  });
  args[1] = conversions["USVString"](args[1], {
    context: "Failed to execute 'set' on 'URLSearchParams': parameter 2"
  });
  return (_this$impl6 = this[impl]).set.apply(_this$impl6, args);
};
URLSearchParams.prototype.sort = function sort() {
  if (!this || !module.exports.is(this)) {
    throw new TypeError("Illegal invocation");
  }
  return this[impl].sort();
};
URLSearchParams.prototype.toString = function toString() {
  if (!this || !module.exports.is(this)) {
    throw new TypeError("Illegal invocation");
  }
  return this[impl].toString();
};
URLSearchParams.prototype.entries = URLSearchParams.prototype[Symbol.iterator];
URLSearchParams.prototype.keys = function keys() {
  if (!this || !module.exports.is(this)) {
    throw new TypeError("Illegal invocation");
  }
  return module.exports.createDefaultIterator(this, "key");
};
URLSearchParams.prototype.values = function values() {
  if (!this || !module.exports.is(this)) {
    throw new TypeError("Illegal invocation");
  }
  return module.exports.createDefaultIterator(this, "value");
};
Object.defineProperty(URLSearchParams.prototype, Symbol.toStringTag, {
  value: "URLSearchParams",
  writable: false,
  enumerable: false,
  configurable: true
});
var iface = {
  mixedInto: [],
  is: function is(obj) {
    if (obj) {
      if (obj[impl] instanceof Impl.implementation) {
        return true;
      }
      for (var i = 0; i < module.exports.mixedInto.length; ++i) {
        if (obj instanceof module.exports.mixedInto[i]) {
          return true;
        }
      }
    }
    return false;
  },
  isImpl: function isImpl(obj) {
    if (obj) {
      if (obj instanceof Impl.implementation) {
        return true;
      }
      var wrapper = utils.wrapperForImpl(obj);
      for (var i = 0; i < module.exports.mixedInto.length; ++i) {
        if (wrapper instanceof module.exports.mixedInto[i]) {
          return true;
        }
      }
    }
    return false;
  },
  convert: function convert(obj) {
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$context = _ref.context,
      context = _ref$context === void 0 ? "The provided value" : _ref$context;
    if (module.exports.is(obj)) {
      return utils.implForWrapper(obj);
    }
    throw new TypeError("".concat(context, " is not of type 'URLSearchParams'."));
  },
  createDefaultIterator: function createDefaultIterator(target, kind) {
    var iterator = Object.create(IteratorPrototype);
    Object.defineProperty(iterator, utils.iterInternalSymbol, {
      value: {
        target: target,
        kind: kind,
        index: 0
      },
      writable: false,
      enumerable: false,
      configurable: true
    });
    return iterator;
  },
  create: function create(constructorArgs, privateData) {
    var obj = Object.create(URLSearchParams.prototype);
    obj = this.setup(obj, constructorArgs, privateData);
    return obj;
  },
  createImpl: function createImpl(constructorArgs, privateData) {
    var obj = Object.create(URLSearchParams.prototype);
    obj = this.setup(obj, constructorArgs, privateData);
    return utils.implForWrapper(obj);
  },
  _internalSetup: function _internalSetup(obj) {},
  setup: function setup(obj, constructorArgs, privateData) {
    if (!privateData) privateData = {};
    privateData.wrapper = obj;
    this._internalSetup(obj);
    Object.defineProperty(obj, impl, {
      value: new Impl.implementation(constructorArgs, privateData),
      writable: false,
      enumerable: false,
      configurable: true
    });
    obj[impl][utils.wrapperSymbol] = obj;
    if (Impl.init) {
      Impl.init(obj[impl], privateData);
    }
    return obj;
  },
  interface: URLSearchParams,
  expose: {
    Window: {
      URLSearchParams: URLSearchParams
    },
    Worker: {
      URLSearchParams: URLSearchParams
    }
  }
}; // iface
module.exports = iface;
var Impl = require(".//URLSearchParams-impl.js");